import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=e4097f58&scoped=true&"
import script from "./Trades.vue?vue&type=script&lang=js&"
export * from "./Trades.vue?vue&type=script&lang=js&"
import style0 from "./Trades.vue?vue&type=style&index=0&id=e4097f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4097f58",
  null
  
)

export default component.exports